import { IFilter } from "../Tools/IFilter";
import { FilterGroup } from "../Tools/FilterGroup";
import { FiltersController } from "../Tools/FiltersController";


export class PriceRangeFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;

    controller: FiltersController;
    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup) {
        this.id = 'priceRange';
        this.name = 'Interval de prix';
        this.type = 'priceRange';

        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    filterSortHtml(): string {
        let classes = "fas fa-stack-1x";
        if (FilterGroup.filters.sort.price === 1 || FilterGroup.filters.sort.price === 0) {
            classes += " fa-sort-amount-down-alt";
        } else if (FilterGroup.filters.sort.price === 2) {
            classes += " fa-sort-amount-up-alt";
        }
        return `
            <span class="fa-stack">
                <i class="${classes}" style="line-height: 2em;"></i>
                ${!FilterGroup.filters.sort.price ?
                '<i class="fas fa-ban fa-stack-2x" style="color:Tomato"></i>' : ''
            }
            </span>
        `;
    }

    updateFilterSortHtml(): void {
        let container = document.getElementById('priceRangeSort');
        if (container) {
            container.innerHTML = this.filterSortHtml();
        }
    }

    html(): string {
        let html = `
        <div class="filter" style="display: flex;align-items: end;justify-content: center;margin:0 auto;max-width: 380px;width: 100%;">
            <div class="col-xs-11" style="display:flex;flex-direction:column;align-items: center;">
                <div style="display:flex;width:calc(100% + 25px);justify-content:space-between;">
                    <div>Min <span id="priceMin">${FilterGroup.getMinPrice()}</span></div>
                    <span>${this.name}</span>
                    <div>Max <span id="priceMax">${FilterGroup.getMaxPrice()}</span></div>
                </div>
                <div id="priceRangeInput" style="width: 100%;"></div>
            </div>
            <div id="priceRangeSort" style="cursor: pointer; padding: 0;" class="col-xs-1">
                ${this.filterSortHtml()}
            </div>
        </div>
        `;

        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            this.controller.addEventListener('click', () => {
                FilterGroup.filters.sort.price = (FilterGroup.filters.sort.price! + 1) % 3;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters).then(() => {
                    this.updateFilterSortHtml();
                });
            }, 'priceRangeSort');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        let stringFilters = '';
        if (FilterGroup.filters.showContentFactory !== true && FilterGroup.filters.showPriority !== 'CLIENT' && FilterGroup.filters.showPriority !== 'GENERIC' && FilterGroup.filters.showPriority !== 'PLACEHOLDERS') {
            if (![NaN, undefined].includes(FilterGroup.filters.minPrice) && FilterGroup.filters.minPrice! > 0) {
                stringFilters += '&q.price.value.gt=' + FilterGroup.filters.minPrice;
            }

            if (![NaN, undefined].includes(FilterGroup.filters.maxPrice)) {
                stringFilters += '&q.price.value.lt=' + FilterGroup.filters.maxPrice;
            }
        }
        return(stringFilters);
    }

    destroy(): void {
        this.controller.destroy();
    }
}